import React from 'react';
import './SchoolArticle.css';
import * as textHelper from '../../../../utils/TextHelper';
import { PATH } from '../../../../constants';

// todo - try some research about code formatting
// todo ...and possible security problems with current "dangerous" usage
// todo ...(can some harmful code injected into website by modifying data files?)

const getImage = (sheetId, imageName) => (
  <img
    src={`${PATH.SCHOOL}img/${sheetId}/${imageName}.jpg`}
    alt="Článek"
  />
);

const SchoolArticle = ({ sheetId, sectionData }) => (
  <div className="part article">
    {sectionData.image &&
    <div className="image-wrap">
      {sectionData.image.full &&
      <a className="zoom-link" href={`${PATH.SCHOOL}img/${sheetId}/${sectionData.image.name}-full.jpg`} target="_blank">
        {getImage(sheetId, sectionData.image.name)}
        <img
          className="ico-zoom"
          src={`${PATH.IMG}ico/ico-zoom.png`}
          alt=""
        />
      </a>
      }
      {!sectionData.image.full &&
      getImage(sheetId, sectionData.image.name)
      }
      {sectionData.image.source.length > 0 &&
      <div className="note">{sectionData.image.source}</div>
      }
    </div>
    }
    <div dangerouslySetInnerHTML={{ __html: textHelper.formatText(sectionData.text) }} />
  </div>
);

export default SchoolArticle;




// WEBPACK FOOTER //
// ./src/components/App/SchoolDetail/SchoolArticle/SchoolArticle.js